import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AdminService {
  private clearApi = environment.endpoints.adminClear;

  constructor(private http: HttpClient) {}

  /**
   * Requests backend to clear files and vector documents.
   */
  clearFilesAndDocuments(): Observable<void> {
    return this.http.delete<void>(this.clearApi, {});
  }
}
